import React from 'react';
import { CTAButton } from './CTAButton';
export const TestimonialsSection = () => {
  return <section id="pricing" className="w-full bg-white py-16 px-4" data-id="element-730">
      <div className="max-w-5xl mx-auto" data-id="element-731">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-teal-600 mb-8" data-id="element-732">
          Price & Value (Today)
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-733">
          <div className="bg-teal-50 rounded-xl overflow-hidden shadow-lg border-2 border-teal-100 relative" data-id="element-734">
            <div className="absolute top-0 right-0 bg-teal-600 text-white px-4 py-1 rounded-bl-lg font-medium" data-id="element-735">
              BEST VALUE
            </div>
            <div className="p-8 text-center" data-id="element-736">
              <h3 className="font-bold text-2xl mb-3 text-teal-700" data-id="element-737">
                Pair (2 Sleeves)
              </h3>
              <div className="flex justify-center items-center mb-4" data-id="element-738">
                <span className="text-4xl font-bold text-teal-700" data-id="element-739">$64.99</span>
                <span className="ml-2 text-gray-600" data-id="element-740">(=$32.50 each)</span>
              </div>
              <ul className="space-y-3 mb-6 text-left" data-id="element-741">
                <li className="flex items-center" data-id="element-742">
                  <svg className="w-5 h-5 text-teal-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-743">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-744" />
                  </svg>
                  <span className="text-teal-700" data-id="element-745">Free Shipping</span>
                </li>
                <li className="flex items-center" data-id="element-746">
                  <svg className="w-5 h-5 text-teal-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-747">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-748" />
                  </svg>
                  <span className="text-teal-700" data-id="element-749">60-Day Guarantee</span>
                </li>
                <li className="flex items-center" data-id="element-750">
                  <svg className="w-5 h-5 text-teal-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-751">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-752" />
                  </svg>
                  <span className="text-teal-700" data-id="element-753">
                    Free First Size Exchange
                  </span>
                </li>
                <li className="flex items-center" data-id="element-754">
                  <svg className="w-5 h-5 text-teal-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-755">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-756" />
                  </svg>
                  <span className="text-teal-700" data-id="element-757">Ships Friday</span>
                </li>
              </ul>
              <a href="https://silentstruggle.shop/ardava-checkout" className="to-checkout" data-pass-params="1" style={{
              display: 'block'
            }} data-id="element-758">
                <button className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-medium w-full transition-colors" data-id="element-759">
                  Get the Pair TODAY!
                </button>
              </a>
              <p className="text-xs text-gray-500 mt-2" data-id="element-760">
                Price locks at checkout
              </p>
            </div>
          </div>
          <div className="bg-gray-50 rounded-xl overflow-hidden shadow-md" data-id="element-761">
            <div className="p-8 text-center" data-id="element-762">
              <h3 className="font-bold text-2xl mb-3 text-gray-700" data-id="element-763">
                Single Sleeve
              </h3>
              <div className="flex justify-center items-center mb-4" data-id="element-764">
                <span className="text-4xl font-bold text-gray-700" data-id="element-765">$39.99</span>
                <span className="ml-2 text-gray-600" data-id="element-766">+$7.99 shipping</span>
              </div>
              <ul className="space-y-3 mb-6 text-left" data-id="element-767">
                <li className="flex items-center" data-id="element-768">
                  <svg className="w-5 h-5 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-769">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-770" />
                  </svg>
                  <span className="text-gray-600" data-id="element-771">
                    Standard Shipping ($7.99)
                  </span>
                </li>
                <li className="flex items-center" data-id="element-772">
                  <svg className="w-5 h-5 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-773">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-774" />
                  </svg>
                  <span className="text-gray-600" data-id="element-775">60-Day Guarantee</span>
                </li>
                <li className="flex items-center" data-id="element-776">
                  <svg className="w-5 h-5 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-777">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-778" />
                  </svg>
                  <span className="text-gray-600" data-id="element-779">
                    Free First Size Exchange
                  </span>
                </li>
                <li className="flex items-center" data-id="element-780">
                  <svg className="w-5 h-5 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-781">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-782" />
                  </svg>
                  <span className="text-gray-600" data-id="element-783">Ships Friday</span>
                </li>
              </ul>
              <a href="https://silentstruggle.shop/ardava-checkout" className="to-checkout" data-pass-params="1" style={{
              display: 'block'
            }} data-id="element-784">
                <button className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-lg font-medium w-full transition-colors" data-id="element-785">
                  Order Single Sleeve
                </button>
              </a>
              <p className="text-xs text-gray-500 mt-2" data-id="element-786">
                Price locks at checkout
              </p>
            </div>
          </div>
        </div>
        <div className="text-center mb-16" data-id="element-787">
          <p className="text-gray-600 mb-2 text-lg" data-id="element-788">
            Compare: Premium medical sleeves often run $120+ per knee.
          </p>
          <p className="text-sm text-gray-500 italic" data-id="element-789">
            Small-Batch Note: Weekly batches keep feel and finish consistent.
            When a size sells out, restock typically lands in 2–3 weeks.
          </p>
        </div>
        <div className="mb-16" data-id="element-790">
          <h3 className="text-2xl font-bold text-center text-teal-700 mb-8" data-id="element-791">
            Real Customer Photos
          </h3>
          <p className="text-center text-gray-600 mb-8" data-id="element-792">
            See how Ardava fits into real customers' everyday lives
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-793">
            {/* First row */}
            <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-794">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5KHXg3zHKgqrfayXb5c7he/Customer-Review1.webp" alt="Customer wearing Ardava sleeves with casual attire" className="w-full h-48 object-cover rounded-lg mb-2" data-id="element-795" />
              <p className="text-sm text-gray-700 text-center" data-id="element-796">
                "Perfect fit with my everyday clothes"
              </p>
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-797">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ukTapPRMm1Ajkr84C4HtbL/Customer-Review2.webp" alt="Customer wearing Ardava sleeves with athletic socks" className="w-full h-48 object-cover rounded-lg mb-2" data-id="element-798" />
              <p className="text-sm text-gray-700 text-center" data-id="element-799">
                "Great with my workout gear"
              </p>
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-800">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j2kRvswVCzA4Ye3iQR5rmt/Customer-Review4.webp" alt="Close-up of Ardava sleeve showing comfort fit" className="w-full h-48 object-cover rounded-lg mb-2" data-id="element-801" />
              <p className="text-sm text-gray-700 text-center" data-id="element-802">
                "Stays in place during my evening relaxation"
              </p>
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-803">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jAeo3vnsjGLjx8Wuio5tZu/Customer-Review9.webp" alt="Customer wearing Ardava sleeve with ripped jeans" className="w-full h-48 object-cover rounded-lg mb-2" data-id="element-804" />
              <p className="text-sm text-gray-700 text-center" data-id="element-805">
                "Works perfectly under my favorite jeans"
              </p>
            </div>
            {/* Second row - featured larger images */}
            <div className="bg-white p-3 rounded-lg shadow-sm md:col-span-2" data-id="element-806">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7bS4AiV7z9tV4oCUDd1a7J/Customer-Review22.webp" alt="Close-up of Ardava sleeve texture and fit" className="w-full h-48 object-cover rounded-lg mb-2" data-id="element-807" />
              <p className="text-sm text-gray-700 text-center" data-id="element-808">
                "Love the soft texture against my skin"
              </p>
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm md:col-span-2" data-id="element-809">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d1qup7jUfPnzN1Skym8jBe/Customer-Review8.webp" alt="Customer wearing Ardava sleeve outdoors" className="w-full h-48 object-cover rounded-lg mb-2" data-id="element-810" />
              <p className="text-sm text-gray-700 text-center" data-id="element-811">
                "Perfect for outdoor activities"
              </p>
            </div>
            {/* Third row */}
            <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-812">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8iC98kG3sDX9HkjyurjG1U/Customer-Review10.webp" alt="Customer wearing Ardava sleeves while relaxing" className="w-full h-48 object-cover rounded-lg mb-2" data-id="element-813" />
              <p className="text-sm text-gray-700 text-center" data-id="element-814">
                "Comfortable all day at home"
              </p>
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-815">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qQs3Gickv5NKjiKFJXZzb6/Customer-Review23.webp" alt="Customer wearing Ardava sleeve with white sock" className="w-full h-48 object-cover rounded-lg mb-2" data-id="element-816" />
              <p className="text-sm text-gray-700 text-center" data-id="element-817">
                "Pairs perfectly with any sock - no bunching"
              </p>
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-818">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tYUHpzNDZJUuQCiro4dzxs/Customer-Review14.webp" alt="Customer wearing Ardava sleeve while driving" className="w-full h-48 object-cover rounded-lg mb-2" data-id="element-819" />
              <p className="text-sm text-gray-700 text-center" data-id="element-820">
                "Comfortable even on long drives"
              </p>
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-821">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pqhe7T7crj2jUcBm5cwsJx/Customer-Review24.webp" alt="Customer wearing Ardava sleeve while relaxing on carpet" className="w-full h-48 object-cover rounded-lg mb-2" data-id="element-822" />
              <p className="text-sm text-gray-700 text-center" data-id="element-823">
                "Comfortable support while relaxing at home"
              </p>
            </div>
          </div>
          <div className="text-center" data-id="element-824">
            <p className="text-gray-600 italic mb-4" data-id="element-825">
              "These photos are from verified buyers who've experienced the
              Ardava difference"
            </p>
            <a href="https://silentstruggle.shop/ardava-checkout" className="to-checkout" data-pass-params="1" data-id="element-826">
              <button className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-2 rounded-lg font-medium" data-id="element-827">
                Join Thousands of Satisfied Customers
              </button>
            </a>
          </div>
        </div>
        <div className="bg-teal-50 rounded-xl p-8 shadow-md" data-id="element-828">
          <h3 className="text-2xl font-bold text-center text-teal-700 mb-6" data-id="element-829">
            Sizing Help (Easy)
          </h3>
          <div className="mb-8" data-id="element-830">
            <div className="bg-white rounded-lg overflow-hidden border border-gray-200 max-w-2xl mx-auto" data-id="element-831">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hVmNp8nrvRfj77Q1wjFMCv/sizingCHart.webp" alt="Size chart with thigh measurement guide" className="w-full" data-id="element-832" />
            </div>
            <p className="text-sm text-center mt-2 text-gray-700" data-id="element-833">
              Measure 4" above the patella (kneecap) for the perfect fit
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-834">
            <div className="text-center" data-id="element-835">
              <div className="bg-teal-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-836">
                <span className="text-teal-700 font-bold text-xl" data-id="element-837">1</span>
              </div>
              <p className="text-gray-700" data-id="element-838">
                Measure 4" above the center of your kneecap.
              </p>
            </div>
            <div className="text-center" data-id="element-839">
              <div className="bg-teal-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-840">
                <span className="text-teal-700 font-bold text-xl" data-id="element-841">2</span>
              </div>
              <p className="text-gray-700" data-id="element-842">
                Check the size chart above for your perfect fit.
              </p>
            </div>
            <div className="text-center" data-id="element-843">
              <div className="bg-teal-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-844">
                <span className="text-teal-700 font-bold text-xl" data-id="element-845">3</span>
              </div>
              <p className="text-gray-700" data-id="element-846">
                Still unsure? You're covered by our Perfect Fit Guarantee—your
                first size exchange is free and fast.
              </p>
            </div>
          </div>
          <div className="text-center" data-id="element-847">
            <a href="https://silentstruggle.shop/ardava-checkout" className="to-checkout" data-pass-params="1" data-id="element-848">
              <button className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-medium" data-id="element-849">
                Find Your Size & Get a Pair — 60-Day Guarantee
              </button>
            </a>
            <p className="text-xs text-gray-600 mt-2" data-id="element-850">
              Ships Friday · Price locks at checkout
            </p>
          </div>
        </div>
      </div>
    </section>;
};